import React, { useEffect, useState } from "react";
import Course1 from "./Course1";
import Course2 from "./Course2";
import { noAuthConfig } from "../../../../api-config/authConfig";
import { useTranslation } from "react-i18next";
import axios from "axios";
function Courses({ myRef }) {
  const { t } = useTranslation();
  const [allcourse, setallcourse] = useState([]);
  const [allcourseid, setallcourseid] = useState([]);
  const [course, setcourse] = useState("all");

  useEffect(() => {
    axios.get(`https://m2elearning.com/e_learning_api-v2/api/allcourses`)
      .then((res) => {
        setallcourse(res.data.data);
        // console.log(res.data.data);
        const uniqueValues = (key) => {
          const uniqueSet = new Set();
          const result = [];

          res.data.data.forEach((item) => {
            const value1 = item["cd_course_category_id"];
            const value2 = item["cc_course_category_name"];
            if (value2 !== "") {
              const combinedValue = `${value1}-${value2}`;

              if (!uniqueSet.has(combinedValue)) {
                uniqueSet.add(combinedValue);
                result.push({ id: value1, name: value2 });
              }
            }
          });
          return result;
        };
        const uniqueNames = uniqueValues("cc_course_category_name");
        setallcourseid(uniqueNames);
      })
      .catch((err) => {
        console.log(err, "err");
      });
  }, []);

  return (
    <div ref={myRef} className="course">
      <div className="course-text-head">
        <h2> {t("Our Most Popular Courses")}</h2>
      </div>

      <Course1 allcourse={allcourseid} setcourse={setcourse} />
      {/* <h5>{t("Course details")} </h5> */}
      <Course2 allcourse={allcourse} course={course} />
    </div>
  );
}

export default Courses;
